export default __webpack_public_path__ + "static/truebeam-281254587974acb9bcb98e5be79a7d3e.png";